import React, { useEffect, useState } from 'react';
import _get from 'lodash/get';
import { client } from 'cccisd-apollo';
import IconUp from 'cccisd-icons/arrow-up2';
import {
    SecureMessagingSingleConversation,
    SecureMessagingMultipleConversations,
} from 'cccisd-laravel-secure-messaging';
import Loader from 'cccisd-loader';
import messageParticipantsQuery from './messageParticipants.graphql';
import style from './style.css';

const Appdefs = window.cccisd.appDefs;
const Fortress = window.cccisd.fortress;

function TfhMessagingParent() {
    const [conversations, setConversations] = useState(null);
    const [allCoaches, setAllCoaches] = useState(null);

    const parent = {
        id: Fortress.user.pawnId,
        username: Fortress.user.username,
        firstName: Fortress.user.firstName,
        lastName: Fortress.user.lastName,
    };

    useEffect(() => {
        async function getConversations() {
            const resp = await client.query({
                query: messageParticipantsQuery,
                variables: { pawnId: Fortress.user.pawnId },
            });
            let currentInstructors = _get(resp, 'data.groups.tfhClass.targetedByPawns.tfhInstructorList', []) || [];
            const currInstructorPawnIdMap = {};
            currentInstructors = currentInstructors.map(instructor => {
                currInstructorPawnIdMap[instructor.pawn.pawnId] = true;
                return {
                    id: instructor.pawn.pawnId,
                    ...instructor.user,
                };
            });
            setAllCoaches(currentInstructors);

            // old convos are displayed in read-only mode; current coaches can be actively messaged
            const convos = _get(resp, 'data.messages.secureConversationList', []);
            const convosToDisplay = {};
            currentInstructors.forEach(instructor => {
                convosToDisplay[instructor.id] = {
                    readonly: false,
                    ...instructor,
                };
            });

            convos.forEach(convo => {
                const otherParticipant = convo.participantList.find(part => {
                    return part.pawn.pawnId !== Fortress.user.acting.id;
                });

                const isCurrentCoach = otherParticipant.pawn.pawnId in currInstructorPawnIdMap;

                if (isCurrentCoach || convo.messageCount === 0) {
                    return;
                }

                convosToDisplay[otherParticipant.pawn.pawnId] = {
                    readOnly: true,
                    id: otherParticipant.pawn.pawnId,
                    ...otherParticipant.user,
                };
            });

            setConversations(Object.values(convosToDisplay));
        }

        getConversations();
    }, []);

    function scrollToTop() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }

    if (conversations === null) {
        return <Loader loading />;
    }

    let noCoachWarning = null;
    if (!Array.isArray(allCoaches) || allCoaches.length === 0) {
        let coachLabel = 'TFH Coach';
        try {
            coachLabel = Appdefs.pawn.roles.find(r => r.handle === 'tfhInstructor').label;
        } catch (e) {
            coachLabel = 'TFH Coach';
        }
        noCoachWarning = (
            <div className="alert alert-info mb-4">
                <p className="mb-0">Messaging is not active because you have no {coachLabel} assigned.</p>
            </div>
        );
    }

    return (
        <div>
            {noCoachWarning}
            <div className="alert alert-light mb-4">
                <p className="mb-0">
                    These messages can only be viewed by <b>{Fortress.user.acting.user.username}</b> and the recipient.
                    Other family members are restricted from viewing these messages.
                </p>
            </div>
            {conversations.length > 1 ? (
                <SecureMessagingMultipleConversations primaryParticipant={parent} anotherParticipants={conversations} />
            ) : (
                <SecureMessagingSingleConversation primaryParticipant={parent} anotherParticipant={conversations[0]} />
            )}

            <div className={style.backToTop}>
                <button className="btn btn-link" type="button" onClick={scrollToTop}>
                    <IconUp spaceRight />
                    Scroll to Top
                </button>
            </div>
        </div>
    );
}

export default TfhMessagingParent;
